exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select2-search--dropdown .select2-search__field {\n  padding: 0.3rem 0.6rem 0.3rem 1.9rem;\n}\n.select2-search--dropdown {\n  padding: 0.5rem;\n}\n.select2-search--dropdown:after {\n  left: 1.2rem;\n}", ""]);

// exports
